var render = function render(){var _vm=this,_c=_vm._self._c;return _c('span',[_vm._v(_vm._s(_vm.$n(_vm.priceDiff, 'currency'))+" "+_vm._s(_vm.$tc('base.priceType', _vm.exclTax)))])
}
var staticRenderFns = []

export { render, staticRenderFns }